import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Loader } from '../components/Loader.js';
import { callFetch } from '../helpers/fetch.js';
import { SSO_API_URL } from '../sso-secrets.js';

export function SignOutPage() {
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const redirectURL = params.get('redirect_url');

  useEffect(() => {
    const runSignOut = async () => {
      const response = await callFetch(
        `${SSO_API_URL}/api/sso-client/sign-out`,
      );

      if (response?.ok) {
        window.location.href = `${SSO_API_URL}/complete-sign-out?redirect_url=${redirectURL}`;
        return;
      }
    };

    runSignOut();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Loader />;
}
